import * as actionTypes from "../constants/actionTypes";

// reducer initial state
export const initialState = {
  loaded: false,
  loggedIn: false,
  uid: null
};

// reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADED:
      return {
        ...state,
        loaded: true,
        loggedIn: action.payload.loggedIn,
        uid: action.payload.uid
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/auth.js